// Maps assistant endpoints to their loading UI strategy
export type AgentLoadingStrategy = 'dynamic_state_machine' | 'static_spinner'

const STRATEGY_REGISTRY: Readonly<Record<string, AgentLoadingStrategy>> = {
    'issue-resolution': 'dynamic_state_machine',
}

export const getAgentLoadingStrategy = (endpoint?: string): AgentLoadingStrategy =>
    (endpoint ? STRATEGY_REGISTRY[endpoint] : undefined) ?? 'static_spinner'
